/* istanbul ignore file */
import SimpleList, { SimpleListProps } from './SimpleList';

const GroupedList = ({ children, ...props }: SimpleListProps) => {
  return <SimpleList {...props}>{children}</SimpleList>;
};

export default GroupedList;
